
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { PageInWP } from "@/lib/singularity/wp-page-manager/types";
import {
  deletePageFromWP,
  updatePageInWP,
  getPagesFromWPAndPlaceInStore
} from "@/lib/singularity/wp-page-manager/pages";
import { saveToWordPressWithErrorsLoggedToUiStore } from "@/lib/wordpress/save";
import { replaceDocumentWithAnother } from "@/lib/wordpress/load";
import IconButton from "@/components/UI/IconButton.vue";
import Icon from "@/components/UI/Icon.vue";
import { documentStore, singularityStore } from "@/store/store";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import { setAsHomepage } from "@/futurelayer/pages/set-as-homepage";
import InlineTextEdit from "@/components/Singularity/components/InlineTextEdit.vue";

@Component({
  components: {
    IconButton,
    Icon,
    Dropdown,
    InlineTextEdit
  }
})
export default class WPPageManagerPage extends Vue {
  @Prop()
  value!: PageInWP;

  get isHomepage() {
    return singularityStore.homepageInWP === this.value.id;
  }

  get isOpeningPageThisPage() {
    return singularityStore.isOpeningPageId === this.value.id;
  }

  additionalOpen = false;
  openAdditional() {
    this.additionalOpen = !this.additionalOpen;
  }

  async openInCanvas() {
    singularityStore.setIsOpeningPageId(this.value.id);
    await saveToWordPressWithErrorsLoggedToUiStore();
    await replaceDocumentWithAnother(this.value.id);
    singularityStore.setSingularityLeftPanel("page_structure");
    singularityStore.setIsOpeningPageId(false);
  }

  deleteInProgress = false;

  async deletePage() {
    const confirmed = confirm(
      `Are you sure you want to delete the page "${this.value.title}"?`
    );

    if (!confirmed) {
      return;
    }

    this.deleteInProgress = true;
    await deletePageFromWP(this.value.id);
    this.deleteInProgress = false;

    this.$emit("page-deleted", this.value.id);
  }

  editingTitle = false;

  newTitle = "";
  setEditMode() {
    this.editingTitle = true;
  }

  get pageInStore() {
    return singularityStore.pagesInWP.find(page => page.id === this.value.id);
  }

  updateInProgress = false;
  async updatePage(newTitle: string) {
    console.log("Updating page title to:", newTitle);
    if (!newTitle.trim()) {
      this.editingTitle = false;
      return;
    }
    this.updateInProgress = true;
    await updatePageInWP(this.value.id, newTitle);

    this.updateInProgress = false;
    this.editingTitle = false;
    this.$emit("page-updated");
  }

  setAsHomepageInProgress = false;
  async setAsHomepage() {
    this.setAsHomepageInProgress = true;
    await setAsHomepage(this.value.id);
    this.setAsHomepageInProgress = false;
  }

  get active() {
    return this.value.id === documentStore.document.documentMeta.id;
  }

  get classList() {
    return {
      "is-active": this.active,
      "is-opening": this.isOpeningPageThisPage,
      "is-deleting": this.deleteInProgress,
      "is-updating": this.updateInProgress,
      "is-setting-as-homepage": this.setAsHomepageInProgress,
      "is-generating": this.value.generatingInBackground
    };
  }
}
